import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Dock } from "../../models/Dock";

/**
 * Generated class for the DockItem component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'dock-item',
  templateUrl: 'dock-item.html'
})
export class DockItem {

  @Input('item') item: Dock
  @Output('toggle') toggledDock: EventEmitter<any> = new EventEmitter()
  @Output('show') showDock: EventEmitter<any> = new EventEmitter()

  toggleItem(event) {
    this.toggledDock.emit({id: this.item.id, active: this.item.active})
  }

  showItem() {
    this.showDock.emit(this.item)
  }
}



// WEBPACK FOOTER //
// ./src/components/dock-item/dock-item.ts